interface ChatEmptyProps {
  title: string
  description: string
}

const ChatEmpty = (props: ChatEmptyProps) => {
  const { title, description } = props

  return (
    <div className="animate-fade-in-bottom flex h-full w-full items-center justify-center transition-all">
      <div className="grid h-fit grid-rows-2">
        <div className="text-on-surface text-center text-xl font-bold">{title}</div>
        <div className="text-on-surface-subdued text-center text-lg">{description}</div>
      </div>
    </div>
  )
}

export { ChatEmpty }
